export default   {
    Planner: 0,
    PlannerViewer: 1, 
  }; 